var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg31 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "31")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M65.59,11.14h.14a1.63,1.63,0,0,1,.38.3l13,13a1.63,1.63,0,0,1,.3.38V25a3.14,3.14,0,0,1-.46.47L59.35,45c-.52.52-.52.52,0,1L78.72,65.44c.54.54.53.54,0,1.07L66.06,79.17c-.58.58-.58.58-1.16,0L45.53,59.79l-.25-.25a.26.26,0,0,0-.42,0l-.3.3L24.91,79.48c-.51.51-.51.51-1,0L11,66.61c-.45-.45-.45-.53,0-1L30.68,46l.2-.2c.32-.32.32-.32,0-.63l-9.6-9.6-9.92-9.92-.27-.27a.34.34,0,0,1,0-.55l.22-.22L24.06,11.82l.25-.25a.34.34,0,0,1,.52,0l.3.3L44.56,31.29c.4.4.4.4.81,0L65.11,11.53A1.82,1.82,0,0,1,65.59,11.14Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg31, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/31.cd3ed9a4.svg";
export { ForwardRef as ReactComponent };